import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import ATMMultiSelect from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { handleValidNumber, handleValidPercent } from "src/utils/validations/numberInput";
import { AchievementFormValues } from "../Add/AddAchievementWrapper";

type Props = {
  formikProps: FormikProps<AchievementFormValues>;
  onClose: () => void;
  formType: "ADD" | "EDIT";
  selectedGoals: any
};


const AddAchievementForm = ({
  formType = "ADD",
  formikProps,
  onClose,
  selectedGoals
}: Props) => {
  const formHeading = formType === "ADD" ? "Add Achievement" : "Update Achievement";
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="flex flex-col gap-6 p-4">
      <div className="flex items-center justify-between">
        <div className="text-xl font-medium"> {formHeading} </div>
        <button
          type="button"
          className="p-2 rounded hover:bg-hover"
          onClick={onClose}
        >
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <ATMDatePicker
            required
            label="Achieve Date"
            name="achieveDate"
            format="DD/MM/YYYY"
            value={values.achieveDate}
            onChange={(newValue) => setFieldValue("achieveDate", newValue)}
          />
        </div>

        {/* Members */}
        <ATMMultiSelect
          name="achievedById"
          required
          value={values?.achievedById}
          label="Achieved By"
          placeholder="Select achieved by"
          onChange={(newValue) => {
            setFieldValue("achievedById", newValue);
          }}
          options={selectedGoals?.membersInvolved?.map(
            (ele: any) => {
              return {
                label: `${ele?.memberFirstName} ${ele?.memberLastName}`,
                value: ele?.memberId,
              };
            }
          )}
        />
        {selectedGoals?.achieved ?
          <div className="font-medium text-m">Achived : {selectedGoals?.achieved}{selectedGoals?.type === 'COUNTABLE' ? null : '%'} </div>
          : null}
        <ATMTextField
          required
          name="achieved"
          value={values.achieved}
          onChange={(e) => {
            let finalUncountable: any = 100 - selectedGoals?.achieved
            if (selectedGoals?.type === 'COUNTABLE') {
              handleValidNumber(e) && setFieldValue("achieved", e.target.value)
            }
            else {
              if (handleValidPercent(e) && e.target.value <= finalUncountable) {
                setFieldValue("achieved", e.target.value)
              }
            }
          }}
          label="Achievement"
          placeholder="Enter Achieved"
          className="mt-0 rounded"
          onBlur={handleBlur}
        />
      </div>

      <div>
        <ATMTextField
          name="remark"
          value={values.remark}
          onChange={(e) => setFieldValue("remark", e.target.value)}
          label="Remark"
          placeholder="Enter remark"
          onBlur={handleBlur}
        />
      </div>

      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default AddAchievementForm;
